import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchAbsenceProofs = (
  meetingId: string,
  setProofs: Function,
  setIsLoading: Function,
  language: string
) => {
  setIsLoading(true);

  ApiService.get(`meetings/${meetingId}/absence-proofs`)
    .then((response) => {
      setProofs(response.data.meeting_absences_proofs);
    })
    .catch((error) => {
      console.error("Error fetching absence proofs:", error);
      alert(translate(language, "PAGES.MEETING.ABSENCE_PROOFS.ERROR.FETCH"));
    })
    .finally(() => {
      setIsLoading(false);
    });
};
